import { ROUTES } from '@dashboard/router/routeNames'
import { LEAD_ALERTS_PERMISSION } from '@dashboard/modules/visitors/peoplePagesAccess'

export default [
  {
    name: ROUTES.LEAD_ALERTS,
    path: 'people/lead-alerts',
    component: () => import('./pages/LeadAlerts.vue'),
    meta: {
      title: 'Lead alerts',
      description: 'Get an email when someone in your email platform shows buying intent on your website.',
      requiredPermission: LEAD_ALERTS_PERMISSION
    }
  }
]
